import { useTranslation } from 'react-i18next'
import { Main } from '@/components/layout'
import { useAuthStore } from '@/stores/auth-store'
import { SlotMachineGame } from './components/slot-machine-game'
import { useSlotMachineStatus } from './hooks/use-slot-machine'

export function SlotMachinePage() {
  const { t } = useTranslation()
  const { data: status, isLoading } = useSlotMachineStatus()

  const handleBack = () => {
    window.history.back()
  }

  if (isLoading) {
    return (
      <Main>
        <div className='flex items-center justify-center min-h-[60vh]'>
          <span className='text-muted-foreground'>{t('Loading...')}</span>
        </div>
      </Main>
    )
  }

  if (!status?.enabled) {
    return (
      <Main>
        <div className='flex items-center justify-center min-h-[60vh]'>
          <div className='text-center space-y-2'>
            <p className='text-lg font-medium text-muted-foreground'>{t('Slot machine is not available')}</p>
            <p className='text-sm text-muted-foreground/60'>{t('This feature is currently disabled')}</p>
          </div>
        </div>
      </Main>
    )
  }

  return (
    <Main>
      <SlotMachineGame onBack={handleBack} status={status} />
    </Main>
  )
}
